module.exports = __webpack_public_path__ + "static/banner-moc-1-1-ed5e299807e1cc7de0cd6a8fb10ee397.png";